import { render } from "./showErrors.vue?vue&type=template&id=39011313"
import script from "./showErrors.vue?vue&type=script&lang=js"
export * from "./showErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__